module.exports = __WEBPACK_EXTERNAL_MODULE__tanstack_react_query__;